import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

const I18N_VALUES = {
  'es-CO': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  }
};

export class I18n {
  language = 'es-CO';
}

@Injectable({ providedIn: 'root' })

export class DateFormatService extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'DD/MM/YYYY';

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      const mdt = moment(value, this.DT_FORMAT);
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (!date) { return ''; }
    const mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) { return ''; }
    return mdt.format(this.DT_FORMAT);
  }
}

@Injectable({ providedIn: 'root' })

export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private i18n: I18n) {
    super();
  }

  getWeekdayShortName = (weekday: number): string => I18N_VALUES[this.i18n.language].weekdays[weekday - 1];

  getMonthShortName = (month: number): string => I18N_VALUES[this.i18n.language].months[month - 1];

  getMonthFullName = (month: number): string => this.getMonthShortName(month);

  getDayAriaLabel = (date: NgbDateStruct): string => `${date.day}-${date.month}-${date.year}`;

  getWeekdayLabel = (weekday: number): string => `${I18N_VALUES[this.i18n.language].weekdays[weekday - 1]}`;
}
